import React from 'react';
import { RadioGroup } from '@atlaskit/radio';
import SectionMessage from '@atlaskit/section-message';
import { ChoiceQuestionStyles } from '../common/commonStyles';
import { ChoiceFieldWrapper, ChoicePlaceholder } from '../common/questionWrappers';
import { EditOtherOption } from './EditOtherOption';
export var EditSingleChoice = function EditSingleChoice(_ref) {
  var _value$value;
  var id = _ref.id,
    options = _ref.options,
    value = _ref.value,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    hasOtherOption = _ref.hasOtherOption,
    otherOptionSelected = _ref.otherOptionSelected,
    otherOptionText = _ref.otherOptionText,
    onOtherOptionTextChange = _ref.onOtherOptionTextChange,
    warningMessage = _ref.warningMessage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChoiceFieldWrapper, {
    isDisabled: false,
    isInvalid: isInvalid
  }, /*#__PURE__*/React.createElement("div", null, options !== null && options !== void 0 && options.length ? /*#__PURE__*/React.createElement(ChoiceQuestionStyles, null, /*#__PURE__*/React.createElement(RadioGroup, {
    name: id,
    options: options.map(function (option) {
      return {
        label: option.label,
        value: option.value
      };
    }),
    value: (_value$value = value === null || value === void 0 ? void 0 : value.value) !== null && _value$value !== void 0 ? _value$value : null // When `undefined` this is an uncontrolled component and uses internal state.
    ,
    onChange: onChange,
    "aria-labelledby": "label-".concat(id) // This id is linked to the id  of the label element from RennderQuestion.tsx
    ,
    isRequired: isRequired
  })) : /*#__PURE__*/React.createElement(ChoicePlaceholder, null), hasOtherOption && otherOptionSelected && /*#__PURE__*/React.createElement(EditOtherOption, {
    dropdown: false,
    value: otherOptionText,
    isDisabled: !otherOptionSelected,
    onChange: onOtherOptionTextChange,
    id: id
  }))), warningMessage && /*#__PURE__*/React.createElement(SectionMessage, {
    appearance: "warning"
  }, warningMessage));
};